document.addEventListener('DOMContentLoaded', function () {
    /* -------------------- CartGifts Module -------------------- */
    // Счётчики корзины в шапке (на /cart и all-gifts) и кнопки «+/−» подарков
    // на all-gifts. Все запросы — через window.CartService (кэш, очередь),
    // правила скрытых строк — window.MFClub (assets/club-cart.js).
    (function () {
        const SELECTOR = {
            cartCaption: '.header-cart .icon-caption',
            cartControls: '.cart-controls',
            addBtn: '.addgift',
            qtyControls: '.quantity-controls',
            qtyDisplay: '.quantity-display',
            minusBtn: '.minus-btn',
            plusBtn: '.plus-btn',
            giftsButton: '.gifts__button',
            cartCounters: '.header-cart__count, .cart-count, .cart__count, .header-cart-count'
        };

        const QUANTITY_DEBOUNCE_MS = 300;

        function debounce(fn, ms) {
            let t;
            return function () {
                clearTimeout(t);
                const args = arguments;
                const ctx = this;
                t = setTimeout(() => fn.apply(ctx, args), ms);
            };
        }

        function formatMoney(cents) {
            return (cents / 100).toLocaleString('en-GB', {
                style: 'currency',
                currency: 'GBP'
            });
        }

        function svc() {
            return window.CartService;
        }

        // Целиковая корзина (ответ change/update/clear, detail события cart-updated),
        // в отличие от ответа add.js, где items — только добавленные строки.
        function isFullCart(data) {
            return !!(svc() && svc().isFullCart(data));
        }

        function getCart(forceRefresh = false) {
            return svc().getCart(forceRefresh);
        }

        function getVisibleItemCount(cart) {
            return window.MFClub ? window.MFClub.visibleItemCount(cart) : (cart?.item_count || 0);
        }

        function getVisibleCartTotal(cart) {
            if (window.MFClub) return window.MFClub.visibleTotal(cart);
            return (cart?.items || []).reduce((sum, item) => sum + (item.final_line_price || 0), 0);
        }

        function renderCartCounters(cart) {
            const visibleCount = getVisibleItemCount(cart);

            document.querySelectorAll(SELECTOR.cartCounters).forEach(el => el.textContent = String(visibleCount));

            if (visibleCount === 0) {
                document.querySelectorAll(SELECTOR.cartCaption).forEach(el => {
                    el.textContent = 'Cart';
                });
                return;
            }

            document.querySelectorAll(SELECTOR.cartCaption).forEach(caption => {
                try {
                    const money = formatMoney(getVisibleCartTotal(cart));
                    const cost = caption.querySelector('.cost');

                    if (cost) {
                        cost.textContent = money;
                    } else {
                        caption.textContent = money;
                    }
                } catch (e) {
                    /* ignore */
                }
            });
        }

        async function refreshCartCounters(force = false) {
            try {
                renderCartCounters(await getCart(force));
            } catch (e) {
                console.warn('refreshCartCounters error', e);
            }
        }

        const scheduleRefresh = debounce(function (force) {
            refreshCartCounters(Boolean(force));
        }, 120);

        function getRequestedSectionIds() {
            const ids = [];
            document.querySelectorAll('[data-section-id]').forEach(el => {
                const id = el.dataset.sectionId;
                if (id && !ids.includes(id)) ids.push(id);
            });
            return ids;
        }

        // Управление видимостью контролов для всех блоков по variantId
        function setControlsVisibleForVariant(variantId, visible, quantity = 1) {
            const nodes = document.querySelectorAll(`${SELECTOR.cartControls}[data-variant-id="${variantId}"]`);
            nodes.forEach(node => {
                const addBtn = node.querySelector(SELECTOR.addBtn);
                const qtyControls = node.querySelector(SELECTOR.qtyControls);

                if (visible) {
                    if (addBtn) addBtn.style.display = 'none';
                    if (qtyControls) {
                        qtyControls.style.display = 'flex';
                        const display = qtyControls.querySelector(SELECTOR.qtyDisplay);
                        if (display) display.textContent = quantity;
                    }
                } else {
                    if (addBtn) addBtn.style.display = 'inline-flex';
                    if (qtyControls) qtyControls.style.display = 'none';
                }
            });
        }

        function syncGiftControlsWithCart(cart) {
            if (!cart || !Array.isArray(cart.items)) return;

            document.querySelectorAll(SELECTOR.cartControls).forEach(control => {
                const variantId = control.dataset.variantId;
                // пока по варианту есть отложенное или летящее изменение — экран
                // показывает его цель, чужой ответ её не откатывает
                if (pending.has(String(variantId)) || inFlight.has(String(variantId))) return;
                const cartItem = cart.items.find(item => String(item.variant_id) === String(variantId));

                if (cartItem && cartItem.quantity > 0) {
                    setControlsVisibleForVariant(variantId, true, cartItem.quantity);
                } else {
                    setControlsVisibleForVariant(variantId, false, 0);
                }
            });

            updateMainButton();
        }

        // Быстрые клики по «+/−» не шлют запрос на каждый: цель по варианту
        // копится и уходит одним запросом после паузы. Экран обновляется сразу.
        // Запросы по одному варианту идут строго друг за другом (chains): второй
        // клик с паузой больше дебаунса ждёт ответа первого, иначе он решал бы
        // add/change по снимку корзины без ещё летящей строки и добавлял её
        // второй раз. Пока запрос летит, вариант «занят» (inFlight) — чужие
        // ответы не откатывают его дисплей.
        const pending = new Map(); // variantId -> { target, timer }
        const chains = new Map(); // variantId -> Promise
        const inFlight = new Set();

        function queueQuantity(variantId, target) {
            const id = String(variantId);
            const entry = pending.get(id) || {};
            clearTimeout(entry.timer);
            entry.target = Math.max(0, target);
            entry.timer = setTimeout(() => {
                pending.delete(id);
                const prev = chains.get(id) || Promise.resolve();
                const next = prev.then(() => applyQuantity(id, entry.target));
                chains.set(id, next.catch(() => {}));
            }, QUANTITY_DEBOUNCE_MS);
            pending.set(id, entry);

            setControlsVisibleForVariant(id, entry.target > 0, entry.target);
            updateMainButton();
        }

        // Один запрос на цель: новая строка — add.js (проверка наличия), число —
        // change.js по ключу, ноль — update.js. Ответ change/update — целиковая
        // корзина, повторного /cart.js нет; после add корзину читаем один раз.
        // Снимок корзины — после завершения предыдущего запроса по варианту:
        // после add кэш сервиса сброшен и getCart() сходит на сервер.
        async function applyQuantity(variantId, target) {
            const service = svc();
            const jsCart = window.PXUTheme?.jsCart;
            // замок экрана нужен только на /cart (там есть секция и guards)
            const intent = jsCart?.getCartSectionEl?.() ? jsCart.beginIntent() : 0;
            const sections = getRequestedSectionIds();
            const sectionsUrl = window.location.pathname;

            inFlight.add(String(variantId));
            try {
                const cart = await getCart();
                const line = cart.items.find(item => String(item.variant_id) === String(variantId));
                let data = null;

                if (!line) {
                    if (target > 0) {
                        data = (await service.addItems({
                            items: [{ variantId: Number(variantId), quantity: target }],
                            sections,
                            sectionsUrl
                        })).data;
                        document.dispatchEvent(new CustomEvent('product-added', { detail: data }));
                    }
                } else if (target <= 0) {
                    // удаление — по плану MFClub (сироты, «остались только служебные» → всё)
                    const plan = window.MFClub.removalPlan(cart, [line.key]);
                    if (plan) {
                        data = (await service.updateLines({
                            updates: plan.updates,
                            attributes: plan.attributes,
                            sections,
                            sectionsUrl
                        })).data;
                    }
                } else if (target !== line.quantity) {
                    data = (await service.changeLine({ key: line.key, quantity: target, sections, sectionsUrl })).data;
                }

                if (jsCart?.applyServiceResponse && data && data.sections) jsCart.applyServiceResponse(data);

                const fresh = isFullCart(data) ? data : await getCart(!!data);
                inFlight.delete(String(variantId));
                renderCartCounters(fresh);
                syncGiftControlsWithCart(fresh);
            } catch (e) {
                console.error('CartGifts update error', e);
                try {
                    const fresh = await getCart(true);
                    renderCartCounters(fresh);
                    syncGiftControlsWithCart(fresh);
                } catch (ignore) {
                    /* сеть: следующий клик перечитает */
                }
            } finally {
                inFlight.delete(String(variantId));
                if (intent) jsCart.endIntentIf(intent);
            }
        }

        // Один поток обновления текста основной кнопки Continue/Skip
        const updateMainButton = debounce(function updateMainButtonImmediate() {
            const buttons = document.querySelectorAll(
                '.all-gifts__header__bar__button, .all-gifts__header__sticky-button, ' + SELECTOR.giftsButton
            );
            if (!buttons.length) return;

            let hasVisible = false;
            document.querySelectorAll(SELECTOR.qtyControls).forEach(ctrl => {
                const style = window.getComputedStyle(ctrl);
                if (style && style.display === 'flex') hasVisible = true;
            });

            const labels = (window.all_gifts && window.all_gifts.button) || {};
            const continueLabel = labels.continue || 'Continue';
            const skipLabel = labels.skip || 'Skip';
            buttons.forEach(button => { button.textContent = hasVisible ? continueLabel : skipLabel; });
        }, 60);

        async function init() {
            if (!svc()) {
                console.warn('CartGifts: CartService missing');
                return;
            }
            try {
                const cart = await getCart();
                syncGiftControlsWithCart(cart);
                scheduleRefresh(false);
            } catch (e) {
                console.warn('CartGifts init error', e);
            }
        }

        async function onCartUpdated(detail) {
            try {
                // в detail события уже лежит корзина из ответа мутации — не перечитываем.
                // Ответ add.js корзиной не является; на /cart счётчик шапки уже
                // перерисован из секций ответа (jsCart.applyResponse), а контролов
                // подарков там нет — перечитывать нечего.
                if (!isFullCart(detail) && window.PXUTheme?.jsCart?.getCartSectionEl?.()) return;
                const cart = isFullCart(detail) ? svc().primeCache(detail) : await getCart(true);
                syncGiftControlsWithCart(cart);
                renderCartCounters(cart);
            } catch (e) {
                console.warn('cart-updated handler error', e);
            }
        }

        // пока корзина занята — запоминаем последнюю корзину из события, чтобы
        // после cart:settled не ходить за ней в /cart.js
        let cartUpdatedWhileBusy = null;

        document.addEventListener('cart-updated', function (e) {
            if (window.PXUTheme?.jsCart?.isBusy?.()) {
                cartUpdatedWhileBusy = isFullCart(e.detail) ? e.detail : true;
                return;
            }
            onCartUpdated(e.detail);
        });

        document.addEventListener('cart:settled', function () {
            if (!cartUpdatedWhileBusy) return;
            const pendingCart = cartUpdatedWhileBusy;
            cartUpdatedWhileBusy = null;
            onCartUpdated(pendingCart === true ? null : pendingCart);
        });

        // Делегированный обработчик кликов для add / +/- (единственный обработчик)
        document.addEventListener('click', function (e) {
            const add = e.target.closest(SELECTOR.addBtn);
            const minus = e.target.closest(SELECTOR.minusBtn);
            const plus = e.target.closest(SELECTOR.plusBtn);

            if (!add && !minus && !plus) return;

            e.preventDefault();
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') {
                e.stopImmediatePropagation();
            }

            const control = (add || minus || plus).closest(SELECTOR.cartControls);
            if (!control || !svc()) return;

            const variantId = control.dataset.variantId;
            if (add) {
                queueQuantity(variantId, 1);
                return;
            }

            const queued = pending.get(String(variantId));
            const qtyDisplay = control.querySelector(SELECTOR.qtyDisplay);
            const currentQty = queued
                ? queued.target
                : (parseInt(qtyDisplay ? qtyDisplay.textContent : '0', 10) || 0);
            queueQuantity(variantId, minus ? currentQty - 1 : currentQty + 1);
        }, false);

        // MutationObserver: наблюдаем за появлением .cart-controls и за стилевыми изменениями quantity-controls
        const mo = new MutationObserver(debounce(function (mutations) {
            let needsUpdate = false;
            mutations.forEach(m => {
                if (m.addedNodes && m.addedNodes.length) {
                    needsUpdate = true;
                }
                if (
                    m.type === 'attributes' &&
                    m.target.classList &&
                    (m.target.classList.contains('quantity-controls') || m.target.classList.contains('addgift'))
                ) {
                    needsUpdate = true;
                }
            });

            if (needsUpdate) {
                updateMainButton();
            }
        }, 80));

        const moTarget =
            document.querySelector('.gifts-list') ||
            document.querySelector('.gifts') ||
            document.querySelector(SELECTOR.cartControls) ||
            document.body;

        mo.observe(moTarget, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });

        init();
    })();
});
